<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <!--
          <button type="button" class="navbar-toggle"
                  data-toggle="collapse"
                  data-target="#navigation-example-2"
                  @click="toggleNavbar">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          -->
          <!-- <router-link class="navbar-brand" to="/admin">Tippspiel</router-link> -->
        </div>
        <div class="collapse navbar-collapse">
          <!--
          <ul class="nav navbar-nav navbar-right">
            <router-link to="/register" tag="li">
              <a>Register</a>
            </router-link>
            <router-link to="/admin/overview" tag="li">
              <a>Dashboard</a>
            </router-link>
          </ul>
          -->
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page" data-color=""
           data-image="static/img/background/background-2.jpg">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
                <form id="loginform" @submit.prevent="login" action="#" method="post">
                  <div class="card" data-background="color" data-color="blue">
                    <div class="card-header">
                      <h3 class="card-title">Login</h3>
                    </div>
                    <div class="card-content">
                      <div class="form-group">
                        <label>Email</label>
                        <input v-model="email" type="email" placeholder="Enter email" class="form-control input-no-border">
                      </div>
                      <div class="form-group">
                        <label>Passwort</label>
                        <input v-model="password" type="password" placeholder="Password" class="form-control input-no-border">
                      </div>
                    </div>
                    <div class="card-footer text-center">
                      <button type="submit" class="btn btn-fill btn-wd ">Einloggen</button>
                      <!--
                      <div class="forgot">
                        <router-link to="/register">
                          Passwort vergessen?
                        </router-link>
                      </div>
                      -->
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
          </div>
        </footer>
        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) "></div>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <router-link to="/register" tag="li">
          <a>Register</a>
        </router-link>
        <router-link to="/admin/overview" tag="li">
          <a>Dashboard</a>
        </router-link>
      </ul>
    </div>
  </div>
</template>
<script>
  const jwtdecode = require('jwt-decode')
  export default {
    data () {
      return {
        email: '',
        password: ''
      }
    },
    methods: {
      login () {
        this.$store
          .dispatch('login', {
            email: this.email,
            pass: this.password
          })
          .then(() => {
            const t = this.$store.state.token
            const d = jwtdecode(t)
            this.$log.debug('Login.login ' + JSON.stringify(d))
            this.$router.push({ name: 'Benutzer' })
            /*
            this.$store.dispatch('loadAuthor', this.$store.state.user.id).then(response => {
              this.$log.debug('login.loadAuthor ' + this.$store.state.betgame)
              this.$store.dispatch('loadCompetition', this.$store.state.betgame).then(response => {
                this.$log.debug('login.loadCompetition ' + this.$store.state.competition)
                this.$store.dispatch('loadLastMatchday', this.$store.state.competition).then(response => {
                  this.$log.debug('login.loadLastMatchday')
                  this.$router.push({ name: 'Spieltagssieger' })
                })
              })
            })
            */
            /*

            */
            /*
            this.$store.dispatch('setDefaultValues', { betgame: 1, competition: 1, matchday: 4 }).then(() => {
              this.$router.push({ name: 'Spieltagssieger' })
            })
             */
          }, error => {
            alert(error.toLocaleString())
          })
      },
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Login.vue